export enum RestEcgMeterSoftwareNames {
    CardioPerfect = 'CardioPerfect',
}
